/* HOUSE IX Discovery — homepage intro handoff & first-visit interest quiz */
(() => {
  'use strict';
  if (window.HouseIXDiscovery) return;
  const root = document.querySelector('[data-hix-house-picker]');
  if (!root || !root.querySelector('[data-hix-discovery]')) return;
  const ui = root.querySelector('[data-hix-discovery]');
  const storageKey = 'houseix-discovery-complete-v1';
  const houseOrder = ['ember','vanta','aether','tide'];
  const houses = {
    ember: {
      name: 'EMBER', traits: 'PASSION · CREATION · EXPRESSION',
      title: 'YOUR SPARK BELONGS TO EMBER',
      description: 'Your interests connect with live entertainment, creative expression, and bringing people together through unforgettable experiences.',
      research: 'Event production, artist bookings, live entertainment, and creative experiences.',
      location: 'An Ember-owned performance and entertainment venue.'
    },
    vanta: {
      name: 'VANTA', traits: 'SHADOW · DISCIPLINE · EVOLUTION',
      title: 'YOUR VISION BELONGS TO VANTA',
      description: 'You connect with wellness, nature, food, and the evolution of intentional living.',
      research: 'Plant science, wellness concepts, product innovation, and seasonal culinary development.',
      location: 'A dining destination inspired by seasonal ingredients and local culture.'
    },
    aether: {
      name: 'AETHER', traits: 'VISION · INNOVATION · POSSIBILITY',
      title: 'YOUR FUTURE BELONGS TO AETHER',
      description: 'You are drawn to digital experiences, new technologies, and imagining what comes next.',
      research: 'HOUSE IX’s original digital experience and future interactive technology products.',
      location: 'An Aether Showcase to reveal and experience future technology projects.'
    },
    tide: {
      name: 'TIDE', traits: 'FLOW · CONNECTION · RENEWAL',
      title: 'YOUR FLOW BELONGS TO TIDE',
      description: 'Your interests connect with sound, storytelling, and helping independent creators bring original work to life.',
      research: 'Music, audio innovation, recording, and original media production.',
      location: 'A collaborative Tide recording and multimedia production studio.'
    }
  };
  const questions = [
    {q:'Which future project would you be most excited to help develop?', a:[
      ['An original interactive digital experience','aether'],['A music or media production','tide'],['A live entertainment experience','ember'],['An innovative wellness or culinary concept','vanta']]},
    {q:'Which area of research interests you most?', a:[
      ['Sound design and recording technology','tide'],['Plant science and natural product innovation','vanta'],['Interactive digital systems and technology','aether'],['Live event production and audience experiences','ember']]},
    {q:'If you could build something from scratch, which would you choose?', a:[
      ['A music and media production space','tide'],['A venue for performances and entertainment','ember'],['An original digital platform or product','aether'],['A seasonal dining and wellness concept','vanta']]},
    {q:'Which hands-on experience would you choose?', a:[
      ['Experimenting with digital prototypes','aether'],['Developing a seasonal recipe','vanta'],['Producing a live artist showcase','ember'],['Recording audio and creating visual content','tide']]},
    {q:'Which creative challenge would you enjoy solving?', a:[
      ['Making music production more accessible','tide'],['Making live experiences more memorable','ember'],['Finding new ways for people to interact digitally','aether'],['Exploring new approaches to food and wellness','vanta']]},
    {q:'Which future HOUSE IX location would you want to visit?', a:[
      ['A dedicated live entertainment venue','ember'],['An interactive technology showcase','aether'],['A collaborative recording studio','tide'],['A seasonal dining destination','vanta']]},
    {q:'Which first project would you be most excited to support?', a:[
      ['A new original digital experience','aether'],['A culinary or wellness product prototype','vanta'],['An emerging-artist live event','ember'],['An original music or multimedia release','tide']]},
    {q:'What impact would you like your creativity to have?', a:[
      ['Connecting people through shared experiences','ember'],['Inspiring new approaches to everyday living','vanta'],['Expanding what is possible with technology','aether'],['Helping creators share their original work','tide']]}
  ];
  const find = s => root.querySelector(s);
  const panels = ['intro','question','tie','result'];
  let answers = Array(questions.length).fill(null);
  let optionOrder = [];
  let index = 0, chosen = null, scores = null, tied = [], completedHere = false;
  const isComplete = () => {
    try { return localStorage.getItem(storageKey) === 'true' || completedHere; }
    catch { return completedHere; }
  };
  const shuffle = choices => {
    const list = choices.slice();
    for (let i = list.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i+1));
      [list[i],list[j]] = [list[j],list[i]];
    }
    return list;
  };
  const show = panel => {
    panels.forEach(name => {
      const target = find('[data-hix-discovery-panel="'+name+'"]');
      if (target) target.hidden = name !== panel;
    });
    const titles = {intro:'hix-house-picker-title',question:'hix-discovery-question-title',tie:'hix-discovery-tie-title',result:'hix-discovery-result-title'};
    root.setAttribute('aria-labelledby',titles[panel]);
    if (panel === 'intro') root.setAttribute('aria-describedby','hix-house-picker-description');
    else root.removeAttribute('aria-describedby');
    const focusTarget = find('[data-hix-discovery-panel="'+panel+'"] h2') || find('[data-hix-discovery-start]');
    if (root.open && focusTarget) {
      focusTarget.setAttribute('tabindex','-1');
      focusTarget.focus({preventScroll:true});
    }
  };
  const prepare = () => {
    answers = Array(questions.length).fill(null);
    optionOrder = questions.map(q => shuffle(q.a));
    index = 0; chosen = null; tied=[]; scores=null;
    ui.dataset.house = 'neutral';
    const dismiss = find('[data-hix-discovery-dismiss]');
    if (dismiss) dismiss.hidden = !isComplete();
    show('intro');
  };
  const renderQuestion = () => {
    const current = questions[index];
    find('[data-hix-question]').textContent = current.q;
    find('[data-hix-question-count]').textContent = 'QUESTION '+(index+1)+' OF '+questions.length;
    find('[data-hix-question-percent]').textContent = Math.round((index+1) / questions.length * 100)+'%';
    find('[data-hix-question-fill]').style.width = ((index+1)/questions.length*100)+'%';
    find('[data-hix-question-progress]').setAttribute('aria-valuenow',String(index+1));
    const host = find('[data-hix-answers]');
    host.replaceChildren();
    for (const [label,house] of optionOrder[index]) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'hix-discovery__answer';
      button.dataset.hixDiscoveryAnswer = house;
      button.textContent = label;
      if (answers[index] === house) button.setAttribute('aria-pressed','true');
      host.append(button);
    }
    show('question');
  };
  const calculate = () => {
    scores = Object.fromEntries(houseOrder.map(h=>[h,0]));
    answers.forEach(h => { if (Object.hasOwn(scores,h)) scores[h]++; });
    const high = Math.max(...Object.values(scores));
    tied = houseOrder.filter(h=>scores[h]===high);
    if (tied.length === 1) showResult(tied[0]);
    else {
      const host = find('[data-hix-tie-choices]');
      host.replaceChildren();
      for (const house of tied) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'hix-discovery__answer';
        b.dataset.hixDiscoveryTie = house;
        b.textContent = house.toUpperCase()+' — '+houses[house].traits;
        host.append(b);
      }
      show('tie');
    }
  };
  const showResult = house => {
    if (!houses[house]) return;
    chosen = house;
    const tags = find('[data-hix-house-signup-tags]');
    if (tags) tags.value = 'newsletter, houseix-discovery, houseix-house-' + house;
    const signupButton = find('[data-hix-house-signup-button]');
    if (signupButton) signupButton.textContent = 'JOIN ' + house.toUpperCase() + ' UPDATES';
    const data = houses[house];
    ui.dataset.house = house;
    find('[data-hix-result-title]').textContent = data.title;
    find('[data-hix-result-traits]').textContent = data.traits;
    find('[data-hix-result-description]').textContent = data.description;
    find('[data-hix-result-research]').textContent = data.research;
    find('[data-hix-result-location]').textContent = data.location;
    root.querySelectorAll('[data-hix-result-art]').forEach(node=>{node.hidden = node.dataset.hixResultArt !== house;});
    const secondary = houseOrder.filter(h=>h!==house).sort((a,b)=>scores[b]-scores[a])[0];
    const other = find('[data-hix-result-secondary]');
    other.textContent = secondary && scores[secondary]>0 ? 'You also connected with '+houses[secondary].name+'. You can explore every House after entering.' : 'You can explore every House after entering.';
    show('result');
  };
  const choose = house => {
    answers[index] = house;
    if (index < questions.length - 1) {
      index += 1;
      renderQuestion();
    } else calculate();
  };
  const back = () => {
    if (find('[data-hix-discovery-panel="tie"]').hidden === false) {
      index = questions.length-1;
      renderQuestion();
      return;
    }
    if (index>0) { index--;renderQuestion(); }
    else show('intro');
  };
  const enter = () => {
    if (!chosen || !houses[chosen]) return;
    try { localStorage.setItem(storageKey,'true'); } catch {}
    completedHere = true;
    window.HouseIXPersonalization?.select?.(chosen,true);
    window.HouseIXPersonalization?.close?.(false,false);
    document.dispatchEvent(new CustomEvent('houseix:discovery:complete',{detail:{house:chosen}}));
  };
  root.addEventListener('click',event=>{
    const button = event.target.closest?.('button');
    if (!button || !root.contains(button)) return;
    if (button.hasAttribute('data-hix-discovery-start')) { index=0;renderQuestion(); }
    else if (button.dataset.hixDiscoveryAnswer) choose(button.dataset.hixDiscoveryAnswer);
    else if (button.hasAttribute('data-hix-discovery-back')) back();
    else if (button.dataset.hixDiscoveryTie) showResult(button.dataset.hixDiscoveryTie);
    else if (button.hasAttribute('data-hix-discovery-enter')) enter();
    else if (button.hasAttribute('data-hix-discovery-restart')) prepare();
    else if (button.hasAttribute('data-hix-discovery-dismiss') && isComplete()) window.HouseIXPersonalization?.close?.(false,true);
  });
  const signup = find('#houseix-discovery-signup');
  const signupHouseKey = 'houseix-discovery-signup-house-v1';
  signup?.addEventListener('submit', event => {
    if (!chosen || !houses[chosen]) { event.preventDefault(); return; }
    const tags = find('[data-hix-house-signup-tags]');
    if (tags) tags.value = 'newsletter, houseix-discovery, houseix-house-' + chosen;
    try { sessionStorage.setItem(signupHouseKey,chosen); } catch {}
    try { localStorage.setItem(storageKey,'true'); } catch {}
    completedHere = true;
    window.HouseIXPersonalization?.select?.(chosen,true);
  });
  window.HouseIXDiscovery = {prepare,isComplete};
  prepare();
  const returned = find('[data-hix-signup-postback]');
  if (returned) {
    let savedHouse = null;
    try { savedHouse = sessionStorage.getItem(signupHouseKey) || localStorage.getItem('houseix-chosen-house'); } catch {}
    if (houses[savedHouse]) {
      const revealReceipt = () => {
        // Reopen only when Shopify returned a confirmed success or validation error.
        window.HouseIXPersonalization?.open?.();
        scores = Object.fromEntries(houseOrder.map(h => [h,h === savedHouse ? 1 : 0]));
        showResult(savedHouse);
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',revealReceipt,{once:true});
      else queueMicrotask(revealReceipt);
    }
  }
})();